import { DoctorTreatmentSummaryDto } from "@/data/dto/admin/doctor-treatment-summary-dto";
import { DoctorTreatmentSummaryEntity } from "@/domain/entity/admin/doctor-treatment-summary-entity";
import { formatLocalToYyyyMmDdHhMmSs } from "@/utils/date-util";
import { assertDoctorTreatmentSummaryDto } from "@/utils/validation/generated/doctor-treatment-summary-dto.validator";

export class DoctorTreatmentSummaryMapper {
  static toEntity(dto: DoctorTreatmentSummaryDto): DoctorTreatmentSummaryEntity {
    assertDoctorTreatmentSummaryDto(dto);

    const createdAt = new Date(dto.createdAt);
    const newCreatedAt = formatLocalToYyyyMmDdHhMmSs(createdAt);
    const displayTreatmentUuid = dto.treatmentUuid.split("-")[0];

    return {
      createdAt: newCreatedAt,
      patientId: dto.patientId,
      patientUuid: dto.patientUuid,
      treatmentInfo: {
        displayTreatmentUuid: displayTreatmentUuid,
        treatmentUuid: dto.treatmentUuid,
      },
      detailInfo: {
        step: dto.step ?? 0,
        type: dto.type,
      },
    };
  }
}
